const en = {
  home: {
    createNewButton: "Create New XML Feed",
    uploadHeading: "Upload XML",
    intro: "Easily Create And Edit Podcast XML Feeds",
    footerHeading: "Get the most out of the podcast management experience",
    footerText1:
      "Why should you sign up? You will have access to stored data using any device.",
    footerText2:
      "Get access to PRO features like feed version history, advanced validation, feed hosting, audio file meta data updating and more!",
    signupButton: "Sign Up",
    loginText: "Log In",
  },
  navbar: {
    editorLink: "Editor",
    uploadLink: "Import XML",
    createLink: "Create New",
    saveLink: "Save In Browser",
    loadLink: "Load From Browser",
    publishLink: "Publish XML",
    openXMLLink: "Open XML URL",
    settingsLink: "Account Settings",
    logoutLink: "Log Out",
    signupLink: "Sign Up",
    loginLink: "Log In",
  },
  statusBar: {
    verifyButton: "Verify Data",
    exportButton: "Export XML",
    allValidStatus: "All data is valid",
    generalValidStatus: "General data appears to be valid",
    episodeInvalidStatus: "{{count}} episode has invalid input",
    episodeInvalidStatus_plural: "{{count}} episodes have invalid input",
    generalInvalidStatus: "Form has invalid input",
  },
  tabs: {
    generalTab: "Podcast Info",
    episodeTab: "Edit Episode",
    episodeListTab: "Episodes",
  },
  generalForm: {
    mainTitle: "Podcast General Info",
    titleLabel: "Podcast Title",
    titleError: "Podcast title is required, at least 2 characters.",
    imageUrlLabel: "Image URL, used by podcast apps",
    imageUrlDescription:
      "Supported formats JPG, PNG or GIF. Recommended resolution 1400x1400 px.",
    imageUrlError: "Provide valid URL, starting with http:// or https://",
    subtitleLabel: "Podcast Subtitle",
    subtitleError: "Podcast subtitle is required.",
    summaryLabel: "Podcast Summary",
    summaryError: "Summary must be at least 10 characters long.",
    authorLabel: "Podcast Author(s)",
    authorError: "Names must be at least 2 characters.",
    ownerLabel: "Podcast Owner",
    ownerTip: "Company name, or same as author",
    ownerError: "Required, at least 2 characters.",
    websiteUrlLabel: "Podcast Website URL",
    websiteUrlError: "Provide valid URL, starting with http:// or https://",
    languageLabel: "Language (for example en, ru, es-MX, fr-CA etc.)",
    languageError: "At least one language must be specified in valid format.",
    copyrightLabel: "Copyright",
    copyrightError: "Copyright is required, if not sure enter your name.",
    contactEmailLabel: "Contact Email",
    contactEmailError: "Provide valid email address.",
    categoriesLabel: "Podcast Categories for iTunes",
    categoriesTip: "These are defined by Apple. Specify at least one.",
    categoriesEditLink: "Edit",
    categoriesSelectLink: "Select",
    categoriesError: "Select at least one category",
    keywordsLabel: "Keywords (comma-separated)",
    keywordsError: "Enter at least one keyword.",
    ageRestrictionLabel: "Podcast Age Restrictions",
    ageRestrictionTip:
      "Clean content is suitable for audiences under 18 years of age",
    ageRestrictionClean: "Clean",
    ageRestrictionExplicit: "Explicit",
    ageRestrictionError: "Select one option",
    updadingLabel: "Updating...",
  },
  episodeForm: {
    mainTitle: "Episode",
    unselectedText: "Please select an episode to view and edit it here.",
    previewLink: "Preview",
    previewFallbackEpisodeName: "Episode name",
    previewFallbackPodcastName: "Enter podcast name",
    previewFallbackImageUrl: "Enter podcast artwork image url",
    previewFallbackDate: "Enter episode date",
    previewFallbackTime: "Release time",
    previewFallbackSubtitle: "Episode subtitle will show up here",
    previewFallbackFileURL: "Enter episode file url",
    previewFallbackDescription: "Enter episode description to see it here.",
    titleLabel: "Title",
    titleError: "Episode title is required.",
    subtitleLabel: "Subtitle",
    subtitleError: "Episode subtitle is required.",
    descriptionLabel: "Description",
    descriptionError: "Description must be at least 4 characters long.",
    releaseDateLabel: "Release Date",
    releaseDateError: "Date is required",
    releaseDateNow: "Now",
    releaseDateTip: "Month, day, year, time 12 hrs AM/PM",
    timeLabel: "Time (ex.: 12:00 PM)",
    timeError: "Time is required",
    fileUrlLabel: "MP3 File URL",
    fileUrlError: "Specify a URL for an audio file type .mp3 or .m4a",
    fileSizeLabel: "File size in bytes",
    fileSizeError: "Enter correct length.",
    durationLabel: "Duration",
    hoursLabel: "Hours",
    hoursError: "Hour must be passed as number",
    minutesLabel: "Minutes",
    minutesError: "Minutes must be passed as number",
    minutesError2: "Minutes must be less than 60 when hours are provided",
    secondsLabel: "Seconds",
    secondsError: "Enter correct number of seconds.",
    secondsError2: "Seconds must be less than 60 when minutes are provided",
    ageRestrictionLabel: "Episode Age Restrictions",
    ageRestrictionClean: "Clean",
    ageRestrictionExplicit: "Explicit",
    ageRestrictionError: "Select one option",
    updadingLabel: "Updating...",
  },
  forceExportModal: {
    title: "Warning",
    text1: "This feed contains invalid or missing data.",
    text2:
      "Generate the XML at your own risk. This feed may cause problems with Apple Podcasts Connect and other podcasting directories. Or, it may be just fine.",
    closeButton: "Cancel",
    forceExportButton: "Export Anyway",
  },
  uploadXML: {
    inputLabel: "File URL",
    submitButton: "Submit",
    verticalSeparator: "or",
    selectFileButton: "Select A File",
    dropText: "Drop file here",
  },
  episodeList: {
    mainTitle: "Episodes",
    newButton: "New",
    episodeError: "At least one episode is required",
    episodeTitleFallback: "Episode Title",
    episodeDateFallback: "Episode Date",
    deleteLink: "Delete",
  },
  footer: {
    copyright: "© 2022 Techlife Syndicate",
    version: "Ver",
    privacyLink: "Privacy Policy",
    termsLink: "Terms of Service",
  },
  signup: {
    formTitle: "Sign Up",
    firstnameLabel: "First Name",
    firstnamePlaceholder: "First Name",
    firstnameMinError: "Firstname must be at least 2 characters",
    firstnameMaxError: "Firstname must be at most 15 characters",
    firstnameReqError: "Firstname is required",
    lastnameLabel: "Last Name",
    lastnamePlaceholder: "Last Name",
    lastnameMinError: "Lastname must be at least 2 characters",
    lastnameMaxError: "Lastname must be at most 15 characters",
    lastnameReqError: "Lastname is required",
    emailLabel: "Email",
    emailPlaceholder: "Email",
    emailTypeError: "Email must be a valid email address",
    emailReqError: "Email is a required field",
    passwordLabel: "Password",
    passwordPlaceholder: "Password",
    passwordMinError: "Password must be at least 8 characters",
    passwordReqError: "Password is required",
    signupButton: "Sign Up",
    signupButtonLoading: "Signing up...",
    memberText: "Already a member?",
    loginLink: "Log In",
    mainHeading: "Easily Create And Edit Podcast XML Feeds",
    subHeading: "Why sign up?",
    text1:
      "We make your podcast management experience painless and delightful.",
    text2:
      "Get access to PRO features like feed version history, advanced validation, feed hosting, audio file meta data updating and more!",
  },
  login: {
    formTitle: "Log In",
    emailLabel: "Email",
    emailPlaceholder: "Email",
    emailTypeError: "Email must be a valid email address",
    emailReqError: "Email is a required field",
    passwordLabel: "Password",
    passwordPlaceholder: "Password",
    passwordMinError: "Password must be at least 8 characters",
    passwordReqError: "Password is required",
    loginButton: "Log In",
    loginButtonLoading: "Logging In...",
    notMember: "Not yet a member?",
    signupLink: "Sign up",
  },
  profile: {
    formTitle: "User Profile",
    updateProfileLabel: "Update Personal Info",
    updatePasswordLabel: "Update Password",
    currentPasswordLabel: "Current Password",
    newPasswordLabel: "New Password",
    avatarTitleLabel: "User Image",
    changeAvatarLabel: "Change Profile Image",
    deleteAccountLink: "Delete Account",
  },
  delete: {
    title: "Delete Account",
    warningText:
      "Are you sure you want to delete your account? This is an irreversible process and you will lose all the data stored on the server.",
    buttonText: "Delete Your Account",
  },
  backToEditorText: "Back to editor",
};

export default en;
